<template lang="html">
  <div class="main">
    <p class="percentage">0%</p>
    <div class="namesContainer">
      <div v-for="( element, index ) in data" v-bind:key="index" class="cards">
        <p>{{ element.name }}</p>
      </div>
    </div>
    <div class="chartContainer">
      <div class="line1"></div>
      <div class="line2"></div>
    <div class="line3"></div>
        <div class="line4"></div>
      <svg class="chart"></svg>
    </div>

  </div>
</template>
<script>
/* Imports are written here */
export default {
  components: {

  },
  props: {
    graph_data: Array,
    assetClassColor: String
  },
  data() {
    return {
      data:  [],
    }
  },
  computed:{

  },
  watch:{

  },
  methods: {
    draw(){
      const colors = [ this.assetClassColor, '#E3ECFF', '#B8B8B8', ];

      var data = this.data;
      // We set the styles of our bars
      var width = 220,
      barHeight = 30;

      var x = d3.scale.linear()
      .domain(d3.extent(data, function(d) { return d.value; }))
      .range([0, width]);

      var chart = d3.select(".chart")
      .attr("width", width)
      .attr("height", (barHeight+20) * data.length);
      // Next we initiate the data join by defining the selection to which we will join data.
      var bar = chart.selectAll("g")
      .data(data)
      /* Since we know the selection is empty, the returned update and exit
      selections are also empty, and we need only handle the enter selection
      which represents new data for which there was no existing element.
      We instantiate these missing elements by appending to the enter selection.*/
      .enter().append("g")
      .attr("transform", function(d, i) { return "translate(0," + i * (barHeight+20) +")"; });
      // Now we set the width of each new bar as a multiple of the associated data value, d.
      bar.append("rect")
      .attr("width", function(d) { return x(d.value) * 0.8 + "px"; })
      .attr("height", barHeight - 1)
      .attr("marginTop", barHeight + 10)
      // We can set our colors by iterating between our array
      .attr({
        'fill': (d, i) => colors[i],
      })
      bar.append("text")
      .attr("x", function(d) { return x(d.value) * 0.8 + 2; })
      .attr("y", barHeight / 2)
      .attr("dy", ".35em")
      // Here we set our text the way we want it
      .text(function(d) {
        d = d.value
        // This is multiplied for 1000 an the divided
        // between 10 to aviod bugs by multiplying for 100
        d = d * 1000;
        d = d / 10;
        if ( d % 1 != 0 ){ d = d.toFixed(2)  }
        return d + '%';
      });
    }
  },
  beforeMount(){

  },
  mounted(){
    this.data = this.graph_data;
    this.draw();
  },
}
</script>
<style lang="css" scoped>

.main {
  display: block;
  margin: 0 auto;
  width: 500px;
  max-width: 768px;
  margin-bottom: 1em;
  /* background-color: orange; */
  padding-top: 10px;
}

.percentage {
  color: #848484;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 15px;
  margin-left: 152px;
}

.namesContainer {
  /* background-color: yellow; */
  float: left;
  width: 120px;
  display: inline-block;
  margin-right: 40px;
  padding-top: 24px;
}

.cards {
  height: 50px;
  /* background-color: purple; */
}

.namesContainer p {
 font-size: 14px;
 line-height: 15px;
 font-weight: 600;
 /* background-color: blue; */
 margin: 0px;
}

</style>
<style lang="css">

.chart {
  /* background-color: green; */
  border-left: 1px dashed #E3ECFF;
  padding-top: 24px;
  z-index: 1;
  position: relative;
}

.chartContainer{
  width: 221px;
  height: 124px;
  display: inline-block;
  position: relative;
}

.chartContainer .line1 {
  position: absolute;
  border-right: 1px dashed #E3ECFF;
  height: 100%;
  width: 100%;
  transform: translateX(-44px);
  z-index: 0;
}

.chartContainer .line2 {
  position: absolute;
  border-right: 1px dashed #E3ECFF;
  height: 100%;
  width: 100%;
  transform: translateX(-176px);
  z-index: 0;
}

.chartContainer .line3 {
  position: absolute;
  border-right: 1px dashed #E3ECFF;
  height: 100%;
  width: 100%;
  transform: translateX( -132px  );
  z-index: 0;
}

.chartContainer .line4 {
  position: absolute;
  border-right: 1px dashed #E3ECFF;
  height: 100%;
  width: 100%;
  transform: translateX( -89px  );
  z-index: 0;
}

.chart rect {
  /* fill: steelblue; */
}

.chart text {
  fill: #4A4A4A;
  font-size: 13px;
  line-height: 15px;
  font-weight: 600;
  /* Avenir Next */
  text-anchor: start;
}

</style>



// WEBPACK FOOTER //
// src/components/VerticalTableData.vue